import { z } from 'zod'
import { uuidSchema } from './common'

// PowerBI query schemas
export const powerBIQuerySchema = z.object({
  id: uuidSchema,
  userId: uuidSchema,
  query: z.string().min(1).max(5000),
  response: z.string(),
  branchId: z.string().max(50),
  createdAt: z.date()
})

export const createPowerBIQuerySchema = z.object({
  query: z.string().min(1).max(5000),
  branchId: z.string().max(50)
})

export const powerBIQueryRequestSchema = z.object({
  question: z.string().min(1).max(1000),
  context: z.record(z.string(), z.any()).optional()
})

export const powerBIQueryResponseSchema = z.object({
  answer: z.string(),
  data: z.any().optional(),
  visualizations: z.array(z.object({
    type: z.string(),
    data: z.any(),
    config: z.record(z.string(), z.any()).optional()
  })).optional(),
  confidence: z.number().min(0).max(1).optional()
})

export const powerBIDatasetSchema = z.object({
  id: z.string(),
  name: z.string(),
  tables: z.array(z.object({
    name: z.string(),
    columns: z.array(z.object({
      name: z.string(),
      dataType: z.string(),
      description: z.string().optional()
    }))
  }))
})

export const powerBIReportSchema = z.object({
  id: z.string(),
  name: z.string(),
  webUrl: z.string(),
  embedUrl: z.string(),
  datasetId: z.string()
})

export const powerBIQueryStatsSchema = z.object({
  totalQueries: z.number(),
  averageResponseTime: z.number(),
  successRate: z.number(),
  topQueries: z.array(z.object({
    query: z.string(),
    count: z.number()
  }))
})

// Type exports
export type PowerBIQuery = z.infer<typeof powerBIQuerySchema>
export type CreatePowerBIQuery = z.infer<typeof createPowerBIQuerySchema>
export type PowerBIQueryRequest = z.infer<typeof powerBIQueryRequestSchema>
export type PowerBIQueryResponse = z.infer<typeof powerBIQueryResponseSchema>
export type PowerBIDataset = z.infer<typeof powerBIDatasetSchema>
export type PowerBIReport = z.infer<typeof powerBIReportSchema>
export type PowerBIQueryStats = z.infer<typeof powerBIQueryStatsSchema> 